//EXTERNAL
import { useEffect, useState } from "react";
import { generateFormatHtml } from "@picnicmedia/format-html-generator";
//CONTEXT
import { useCreativeState } from "../../../../contexts/creative.context";
//HELPERS
import { create_creative_clone } from "../../../../helpers/create_creative_clone";
// CONFIGS
import studio_config from "../../../../configs/studio.json";

interface StudioConfig {
  [key: string]: any;
}

export function DynamicFormatPreview() {
  const creative = useCreativeState();
  const studioConfig: StudioConfig = studio_config;
  const [formatPreviewHtml, updateFormatPreviewHtml] = useState<string | undefined>("");

  const frameRatios = studioConfig.formats[creative.metadata.format].media.frameRatios;
  const matchedFrameRatio = frameRatios.findIndex((frameRatio: FrameRatio) => frameRatio.name === creative.metadata.aspectRatio);
  const frameWidth = studioConfig.formats[creative.metadata.format].media.frameRatios[matchedFrameRatio].adSlotWidth;
  const frameHeight = studioConfig.formats[creative.metadata.format].media.frameRatios[matchedFrameRatio].adSlotHeight;

  useEffect(() => {
    generateFormatPreview();
  }, [creative]);

  const generateFormatPreview = async () => {
    //
    // use placeholder assets and text if user hasn't updated info yet
    //
    let creativeClone = create_creative_clone(creative);
    //
    // run format generator function to generate format html and update state
    //
    let formatHtml = await generateFormatHtml(creativeClone);
    updateFormatPreviewHtml(formatHtml);
  };

  return <iframe id="dynamic-preview-iframe" className="bn" srcDoc={formatPreviewHtml} width={frameWidth} height={frameHeight}></iframe>;
}
